export enum SidebarText {
  BACK_BUTTON = 'Retornar',
}
